import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
/**
 * Select component for dropdown selections.
 *
 * UX Notes:
 * - Min height 44px for touch targets
 * - Visible focus ring
 * - Use with visible <label>
 * - Chevron indicates dropdown affordance
 */
const Select = React.forwardRef(({ className, children, ...props }, ref) => {
    return (_jsx("select", { className: cn("flex h-11 w-full appearance-none rounded-md border border-input bg-transparent px-3 py-2 pr-8", "text-base transition-colors duration-200", "focus-visible:border-ring focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring", "disabled:cursor-not-allowed disabled:opacity-50", "bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22%2F%3E%3C%2Fsvg%3E')]", "bg-[length:16px] bg-[right_8px_center] bg-no-repeat", className), ref: ref, ...props, children: children }));
});
Select.displayName = "Select";
export { Select };
//# sourceMappingURL=select.js.map